import { validate as isUuid } from 'uuid';

export type AisLinkMessage = { type: 'labcomplete:link'; url: string };

export const isAisLinkMessage = (data: unknown): data is AisLinkMessage => {
  const message = data as Partial<AisLinkMessage> | null;
  return typeof message === 'object' && message?.type === 'labcomplete:link' && typeof message.url === 'string';
};

// Read without verifying: the redeem checks the session, the token only says which context to ask for
export const contextIdOf = (token: string): string | null => {
  try {
    const payload = (token.split('.')[1] ?? '').replace(/-/g, '+').replace(/_/g, '/');
    const contextId: unknown = JSON.parse(atob(payload))?.contextId;
    return typeof contextId === 'string' && isUuid(contextId) ? contextId : null;
  } catch {
    return null;
  }
};
